export const today = 'Today';
export const yesterday = 'Yesterday';
